export const GRANT_TYPE_AUTHORIZATION_CODE = 'authorization_code';
export const GRANT_TYPE_IMPLICIT = 'implicit';
export const GRANT_TYPE_PASSWORD = 'password';
export const GRANT_TYPE_CLIENT_CREDENTIALS = 'client_credentials';
export const GRANT_TYPE_REFRESH = 'refresh_token';

export const RESPONSE_TYPE_CODE = 'code';
export const RESPONSE_TYPE_ID_TOKEN = 'id_token';
export const RESPONSE_TYPE_TOKEN = 'token';
export const RESPONSE_TYPE_ID_TOKEN_TOKEN = 'id_token token';

export const P_ACCESS_TOKEN = 'access_token';
export const P_CLIENT_ID = 'client_id';
export const P_CLIENT_SECRET = 'client_secret';
export const P_AUDIENCE = 'audience';
export const P_RESOURCE = 'resource';
export const P_CODE = 'code';
export const P_NONCE = 'nonce';
export const P_ERROR = 'error';
export const P_ERROR_DESCRIPTION = 'error_description';
export const P_ERROR_URI = 'error_uri';
export const P_EXPIRES_IN = 'expires_in';
export const P_GRANT_TYPE = 'grant_type';
export const P_PASSWORD = 'password';
export const P_REDIRECT_URI = 'redirect_uri';
export const P_REFRESH_TOKEN = 'refresh_token';
export const P_RESPONSE_TYPE = 'response_type';
export const P_SCOPE = 'scope';
export const P_STATE = 'state';
export const P_TOKEN_TYPE = 'token_type';
export const P_USERNAME = 'username';

export const X_RESPONSE_ID = 'xResponseId';
export const X_ERROR = 'xError';
